// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"7f5b3282","337":"17321c82","603":"df241bab","794":"06a3ce58"}[chunkId] + ".chunk.js";
};